import React, {useRef} from 'react';
import {Headline} from '../../Components/Headline/Headline';
import {OrderSummaryLayout} from '../../Components/OrderSummary/OrderSummaryLayout';
import {useControllerProps} from '../../../../../domain/controllers/ControllerContext';
import s from './CartBody.scss';
import {CheckoutButtons} from '../../Components/CheckoutButtons/CheckoutButtons';
import {useEnvironment} from '@wix/yoshi-flow-editor';
import {useIsAfterHydration} from '../../../../../hooks/useIsAfterHydration';
import {CartBodySkeleton} from '../../Components/CartBodySkeleton/CartBodySkeleton';
import {EmptyStateContent} from '../../Components/EmptyState/EmptyStateContent';
import {CartBody} from './CartBody';

export const CartLayout = ({shouldShowSkeleton}: {shouldShowSkeleton: boolean}) => {
  const {shouldShowTopCheckoutButtonInMobile, shouldRenderEmptyState} = useControllerProps()?.cartStore || {};
  const {isMobile, isEditorX} = useEnvironment();
  const cartLayoutRef = useRef<HTMLDivElement>(null);

  const isAfterHydration = useIsAfterHydration();

  let mainClassName = s.main;

  /* istanbul ignore next */
  if (cartLayoutRef.current?.clientWidth <= 920 || isMobile) {
    mainClassName = 'cartBodyMainOneColumn';
  }

  return (
    <main className={mainClassName} ref={cartLayoutRef}>
      <section className={s.cart}>
        {!shouldShowSkeleton && isMobile && shouldShowTopCheckoutButtonInMobile && !isEditorX && isAfterHydration && (
          <CheckoutButtons isOnTop />
        )}
        <Headline />
        {shouldShowSkeleton && <CartBodySkeleton />}
        {!shouldShowSkeleton && (shouldRenderEmptyState ? <EmptyStateContent /> : <CartBody />)}
      </section>
      {!shouldRenderEmptyState && (
        <aside className={s.summary}>
          <OrderSummaryLayout shouldShowSkeleton={shouldShowSkeleton} />
        </aside>
      )}
    </main>
  );
};
